/**
 * A dónde ir apenas el ERP confirma la sesión: contraseña, Google o SAML.
 *
 * Antes cada pantalla de ingreso repetía el mismo `if` y todas terminaban en
 * `/dashboard`, así que un enlace abierto sin sesión se perdía (#1656). Ahora
 * hay un solo lugar, y respeta el destino que el guard dejó guardado.
 */
import { useAuthStore, type TenantInfo } from '@/store/authStore'
import { descartarDestino, hayDestino, tomarDestino } from '@/lib/destinoTrasLogin'
import { tenantSegunHost } from '@/lib/tenantNav'

interface SesionNueva {
  tenants: TenantInfo[]
  user: { is_platform_admin?: boolean }
}

export function rutaTrasLogin({ tenants, user }: SesionNueva): string {
  if (tenants.length === 0) {
    descartarDestino()
    return user.is_platform_admin ? '/platform' : '/auth/no-access'
  }
  if (tenants.length === 1) return tomarDestino() ?? '/dashboard'

  // Varias empresas. Si la persona venía de un enlace y está en el subdominio de
  // una de ellas, el enlace es de ESA empresa: preguntarle cuál sería un paso de
  // más, y elegir otra lo dejaría sin sentido. Sin enlace pendiente, el selector
  // de siempre.
  if (hayDestino()) {
    const delHost = tenantSegunHost(tenants, null)
    if (delHost) {
      useAuthStore.getState().setActiveTenant(delHost)
      return tomarDestino() ?? '/dashboard'
    }
  }
  return '/auth/select-tenant'
}
